/**
 * Standardized form options used across the application
 * These constants ensure consistency in dropdown values
 */

// Standard title options with proper formatting
export const TITLE_OPTIONS = ["Mr.", "Mrs.", "Ms.", "Dr.", "Prof."];

// Gender options
export const GENDER_OPTIONS = ["Male", "Female"];

// Helper function to render title options for native select elements (class components)
export const renderTitleOptions = (defaultLabel = "-- Select title --", selectedValue = null) => {
  return (
    <>
      <option value="" disabled={!!selectedValue}>
        {selectedValue || defaultLabel}
      </option>
      {TITLE_OPTIONS.map((title) => (
        <option key={title} value={title}>
          {title}
        </option>
      ))}
    </>
  );
};
